import type { WatchContext } from '@dicetechnology/dice-doris';
import { WatchContextType, isWatchContext } from '@dicetechnology/dice-doris';
import { errorToString } from '@dicetechnology/doris-core';

import type { PlaylistLoadRequest, WatchlistLoadRequest } from '../services';
import { DiceReceiverManager } from '../services';

import { isPlaylistLoadRequest } from './isPlaylistLoadRequest';

interface ConfigureWatchContextOptions {
    enableAutoAdvance?: boolean;
    isLive: boolean;
    startingContentId: string;
    watchContext?: WatchContext;
}

export const configureWatchContext = (options: ConfigureWatchContextOptions) => {
    const { enableAutoAdvance = true, isLive } = options;
    if (!enableAutoAdvance || isLive) {
        return;
    }

    const { startingContentId, watchContext } = options;

    const diceReceiverManager = DiceReceiverManager.getInstance();

    if (watchContext != null && isWatchContext(watchContext)) {
        const payload: Partial<PlaylistLoadRequest> = {
            id: watchContext.id,
            startingContentId,
            type: watchContext.type
        };

        if (watchContext.type === WatchContextType.WATCHLIST) {
            (payload as WatchlistLoadRequest).ownerExternalId = watchContext.ownerExternalId;
        }

        if (isPlaylistLoadRequest(payload)) {
            diceReceiverManager
                .getPlaylistManager()
                .updatePlaylistQueue(payload)
                .catch((reason) => {
                    console.error('Failed to update playlist queue', errorToString(reason));
                });
        }
    } else if (diceReceiverManager.getSettings()?.enhancedMetadataViews) {
        // Backwards compatible queueing mechanism for Sender's not using the WatchContext API above
        diceReceiverManager
            .getPlaylistManager()
            .updatePlaylistQueue({
                id: 'unknown', // We don't know this value + its not required for Seasons
                type: WatchContextType.SEASON,
                startingContentId
            })
            .catch((reason) => {
                console.error('Failed to schedule next queue item! Reason: ', errorToString(reason));
            });
    }
};
